<template>
  <div v-once class="img-overlay-wrapper grid-x align-center-middle">
    <!--  attributes are applied surgically to the img tag rather than the root div -->
    <!-- eslint-disable-next-line -->
    <img class="cell" :src :alt v-bind="attrs" />
    <!-- Decorative overlay containing an icon, background color is controlled via mixin modifiers -->
    <div class="overlay-wrapper grid-x align-center-middle" :class="`${isWhite ? 'white-' : ''}overlay-${variation}--background-color`">
      <Icon v-if="iconProps" v-bind="iconProps" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue';
import Icon from '@atomic-ui/icon/Icon.vue';

type OverlayProps = {
  src: string;
  alt: string;
  isWhite?: boolean;
  variation?: 1 | 2;
  iconProps?: object | null;
};

const { src, alt, isWhite = false, variation = 1, iconProps = null } = defineProps<OverlayProps>();

// Disable default inheritance to allow manual binding of attrs (like src, alt) to the inner img tag
defineOptions({ inheritAttrs: false });

const attrs = useAttrs();
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

@include color-overlay-modifiers('background-color', '--');

.img-overlay-wrapper {
  position: relative;
}

.img-overlay-wrapper,
img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.overlay-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
